module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "the-beach"
    }
  }, [_c('h1', [_vm._v("The Beach")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("T")]), _vm._v("ourists gather to these meccas of the shore,")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("H")]), _vm._v("ot spots for life, both human and animal,")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("E")]), _vm._v("veryone loves a sunny day, full of fun, water and peace.")]), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("B")]), _vm._v("eautiful places, wonderful views,")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("E")]), _vm._v("xtraordinary animals gathering under the waves,")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("A")]), _vm._v(" masterpiece of God’s creation, cradling life in abundance,")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("C")]), _vm._v("rashing waves, calm bays, serene headlands,")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("H")]), _vm._v("osting fish, whales, dolphins, turtles, plants and people, all happily playing.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2484ccb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch009.vue
// module id = 84
// module chunks = 0